import React from "react";
import { FlaskConical, Trash2 } from "lucide-react";
import { MicrobiomeSummary } from "@/components/microbiome/MicrobiomeSummary";
import { OrganismBars } from "@/components/microbiome/OrganismBars";

export const SampleList = ({ samples, expandedId, detail, toggle, remove }) => (
  <section className="px-6 sm:px-12 lg:px-20 pb-24 max-w-6xl mx-auto">
    <div className="flex items-center justify-between mb-4">
      <p className="label-eyebrow">Microbiome reports</p>
      {samples.length > 0 && <span className="text-xs text-[#5C6359]" data-testid="microbiome-samples-count">{samples.length} on file</span>}
    </div>
    {samples.length === 0 ? (
      <p className="text-sm text-[#5C6359] bg-[#F1ECE4] border border-[#D1C7B8] rounded-2xl p-6" data-testid="no-microbiome-samples">
        Upload a Bioscreen FMA report above — each analysis becomes a report card here, with your gut terrain mapped over time.
      </p>
    ) : (
      <div className="space-y-3" data-testid="microbiome-samples-list">
        {samples.map((s) => {
          const isOpen = expandedId === s.id;
          const dateLabel = s.date ? new Date(s.date).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" }) : "Undated";
          return (
            <div key={s.id} className="bg-[#F1ECE4] border border-[#D1C7B8] rounded-3xl overflow-hidden" data-testid={`microbiome-card-${s.id}`}>
              <div className="w-full flex items-center justify-between p-5 hover:bg-[#EAE3D9] transition-colors">
                <button onClick={() => toggle(s.id)} className="flex items-center gap-4 text-left flex-1" data-testid={`microbiome-toggle-${s.id}`}>
                  <div className="w-10 h-10 rounded-full bg-[#2D322B] text-[#D49A44] flex items-center justify-center shrink-0">
                    <FlaskConical className="w-4 h-4" />
                  </div>
                  <div>
                    <p className="font-serif text-lg text-[#2D322B] leading-tight">{s.name || "Bioscreen FMA"} · <span className="text-[#5C6359]">{dateLabel}</span></p>
                    <p className="text-xs text-[#5C6359] mt-1">
                      {s.species_detected} species · diversity {s.diversity_label}
                      {s.attention_count > 0 && <span className="ml-2 text-[#8F3A3A]">· {s.attention_count} out of range</span>}
                    </p>
                  </div>
                </button>
                <div className="flex items-center gap-3 shrink-0">
                  <button onClick={() => remove(s.id)} className="text-[#8F3A3A] hover:text-[#C05C42]" data-testid={`microbiome-delete-${s.id}`}>
                    <Trash2 className="w-4 h-4" />
                  </button>
                  <span className={`text-xs uppercase tracking-widest text-[#C05C42] transition-transform ${isOpen ? "rotate-180" : ""}`}>▾</span>
                </div>
              </div>
              {isOpen && (
                <div className="border-t border-[#D1C7B8] p-5 bg-[#F9F6F0] space-y-6" data-testid={`microbiome-detail-${s.id}`}>
                  {!detail ? (
                    <p className="text-sm text-[#5C6359]">Loading…</p>
                  ) : (
                    <>
                      <MicrobiomeSummary summary={detail.summary} diversityNote={detail.sample?.diversity_note} date={detail.sample?.date} />
                      <OrganismBars organisms={detail.organisms} />
                    </>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    )}
  </section>
);
